import baseinfoApi from '@/api/baseinfo'

const baseinfo={
  namespaced:true,
  state:{
    data:[],
    loading:false,
    pagination:{current:1,total:0,pageSize:10,showSizeChanger:true,showTotal:total=>`总计 ${total} 条`},
  },
  mutations:{
    setData:(state,data)=>{
      state.data=data
    },
    setPagination:(state,pagination)=>{
      state.pagination=pagination
    },
    setLoading:(state,loading)=>{
      state.loading=loading
    },
  },
  actions:{
    async GetAll({ commit },input){
      commit('setLoading',true)
      baseinfoApi.getAll(input).then((res)=>{
        commit('setLoading',false)
        commit('setData',res.result.items)
      }).catch(()=>{
        commit('setLoading',false)
      })
    },
    async UpdateOrAdd({ commit },input){
      commit('setLoading',true)
      if(input.id){
        await baseinfoApi.update(input)
      }else{
        await baseinfoApi.create(input)
      }
      commit('setLoading',false)
    },
    async GetPage({ commit },pagination){
      commit('setLoading',true)
      const page={
        skipCount:pagination.pageSize*(pagination.current-1),
        maxResultCount:pagination.pageSize,
        ...pagination
      }           
      try{
        const res=await baseinfoApi.getPage(page)
        pagination.total=res.result.totalCount
        commit('setPagination',pagination)
        commit('setData',res.result.items)
      }finally {
        commit('setLoading',false)
      }
    },
    async Delete({ dispatch,state },info){
      await baseinfoApi.delete(info.id)
      await dispatch('GetPage',state.pagination)
    },
  }
}
export default baseinfo